import data_de from './data-tree-de.json'
import data_fr from './data-tree-fr.json'
import data_it from './data-tree-it.json'

export default {
    ...data_de,
    ...data_fr,
    ...data_it
}